import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=4bab2c63&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bab2c63')) {
      api.createRecord('4bab2c63', component.options)
    } else {
      api.reload('4bab2c63', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=4bab2c63&", function () {
      api.rerender('4bab2c63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dNFJDYnVtZHr/JS/comp/IncreaseNumber.vue"
export default component.exports